function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GamePlayerboxTemplate = require('./playerbox.template');
var SaitoUser = require('./../saito-user/saito-user');

/**
 * Basic template:
 *
 *   Head -- displays SaitoUser component
 *   Body -- information space for games
 *
 */
var GamePlayerBox = /*#__PURE__*/function () {
  /**
   *  @constructor
   *  @param app - Saito app
   */
  function GamePlayerBox(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var publicKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var player_number = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    _classCallCheck(this, GamePlayerBox);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.player_number = player_number;
    this.saito_user = new SaitoUser(this.app, this.mod, ".game-playerbox-head-".concat(this.player_number), publicKey, "Player ".concat(this.player_number), '<div class="game-playerbox-icons"></div>');
  }
  return _createClass(GamePlayerBox, [{
    key: "render",
    value: function render() {
      //
      // add or replace playerbox component
      //
      if (document.querySelector(".game-playerbox-".concat(this.player_number))) {
        this.app.browser.replaceElementBySelector(GamePlayerboxTemplate(this), ".game-playerbox-".concat(this.player_number));
      } else {
        this.app.browser.addElementToSelectorOrDom(GamePlayerboxTemplate(this), "".concat(this.container));
      }

      //
      // render user into playerbox head
      //
      this.saito_user.render();

      //
      // attach events
      //
      this.attachEvents();
    }
  }, {
    key: "remove",
    value: function remove() {
      if (document.querySelector(".game-playerbox-".concat(this.player_number))) {
        document.querySelector(".game-playerbox-".concat(this.player_number)).remove();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      //
      // make draggable
      /*
      this.app.browser.makeDraggable(`game-playerbox-${this.player_number}`, `game-playerbox-head-${this.player_number}`);
      document.querySelector(`#game-playerbox-head-${this.player_number}`).style.cursor = "grab";
      */
      // DO NOT MAKE DRAGGABLE FOR NOW BECAUSE IT SHIFTS THE WHOLE SCREEN
    }
  }, {
    key: "onclick",
    value: function onclick() {
      var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (document.querySelector(".game-playerbox-".concat(this.player_number))) {
        document.querySelector(".game-playerbox-head-".concat(this.player_number, " .saito-user")).setAttribute('data-disable', true);
        document.querySelector(".game-playerbox-head-".concat(this.player_number, " .saito-user .saito-userline")).setAttribute('data-disable', true);
        document.querySelector(".game-playerbox-head-".concat(this.player_number, " .saito-user .saito-address")).setAttribute('data-disable', true);
        document.querySelector(".game-playerbox-head-".concat(this.player_number, " .saito-user .saito-identicon")).setAttribute('data-disable', true);
        document.querySelector(".game-playerbox-".concat(this.player_number)).onclick = function (e) {
          fn();
        };
      }
    }
  }, {
    key: "addClass",
    value: function addClass(classname, target) {
      if (document.querySelector(".".concat(target, "-").concat(this.player_number))) {
        document.querySelector(".".concat(target, "-").concat(this.player_number)).classList.add(classname);
      }
    }
  }, {
    key: "updateAddress",
    value: function updateAddress(address) {
      if (document.querySelector(".game-playerbox-head-".concat(this.player_number, " .saito-user .saito-address"))) {
        document.querySelector(".game-playerbox-head-".concat(this.player_number, " .saito-user .saito-address")).innerHTML = address;
      }
    }
  }, {
    key: "updateUserline",
    value: function updateUserline(userline) {
      if (document.querySelector(".game-playerbox-head-".concat(this.player_number, " .saito-user .saito-userline"))) {
        document.querySelector(".game-playerbox-head-".concat(this.player_number, " .saito-user .saito-userline")).innerHTML = userline;
      }
    }
  }, {
    key: "updateIcons",
    value: function updateIcons(content) {
      if (document.querySelector(".game-playerbox-head-".concat(this.player_number, " .saito-user .game-playerbox-icons"))) {
        document.querySelector(".game-playerbox-head-".concat(this.player_number, " .saito-user .game-playerbox-icons")).innerHTML = content;
      }
    }
  }, {
    key: "updateBody",
    value: function updateBody(content) {
      if (document.querySelector(".game-playerbox-body-".concat(this.player_number))) {
        document.querySelector(".game-playerbox-body-".concat(this.player_number)).innerHTML = content;
      }
    }
  }, {
    key: "updateGraphics",
    value: function updateGraphics(content) {
      if (document.querySelector(".game-playerbox-graphics-".concat(this.player_number))) {
        document.querySelector(".game-playerbox-graphics-".concat(this.player_number)).innerHTML = content;
      }
    }
  }, {
    key: "replaceGraphics",
    value: function replaceGraphics(content, selector) {
      var pb_selector = ".game-playerbox-graphics-".concat(this.player_number);
      if (document.querySelector(pb_selector)) {
        if (document.querySelector("".concat(pb_selector, " ").concat(selector))) {
          this.app.browser.replaceElementBySelector(content, "".concat(pb_selector, " ").concat(selector));
        } else {
          this.app.browser.addElementToSelector(content, pb_selector);
        }
      }
      return "".concat(pb_selector, " ").concat(selector);
    }
  }, {
    key: "hide",
    value: function hide() {
      if (document.querySelector(".game-playerbox-".concat(this.player_number))) {
        document.querySelector(".game-playerbox-".concat(this.player_number)).style.display = 'none';
      }
    }
  }, {
    key: "show",
    value: function show() {
      if (document.querySelector(".game-playerbox-".concat(this.player_number))) {
        document.querySelector(".game-playerbox-".concat(this.player_number)).style.display = 'flex';
      }
    }
  }]);
}();
module.exports = GamePlayerBox;